import { FilterElementsSchema } from '@entities/Filter/module/types/filterElementsSchema';
import { ParamsType } from '@entities/Filter/module/types/filterSchema';

export const generateParams = (schemaFilter: FilterElementsSchema) => {
  const listParamFilter: ParamsType = {};
  schemaFilter.forEach(block => {
    block.elements?.forEach(element => {
      if (Array.isArray(element.name)) {
        element.name.forEach(name => {
          listParamFilter[name] = element.defaultValue || null;
        });
      } else {
        listParamFilter[element.name] = element.defaultValue || null;
      }
    });
  });

  return listParamFilter;
};
